import ProductDashboardContainer from "../containers/ProductDashboardContainer";
import React from "react";

export const ProductDashboardPage: React.FunctionComponent = () => <ProductDashboardContainer />;